import { Route } from "react-router-dom";
import CreateTransport from "../../screens/supply_chain/CreateTransport";

export const transporterRoutes = [
  <Route
    key="transporter-transport"
    path="/transport/:tokenCode"
    element={<CreateTransport />}
  />,
];
